import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Documents } from 'merchant-components'

export const Route = createFileRoute('/_merchant/_portal/documents')({
  component: Documents,
})
